import { AABBModel } from './AABBModel';
import { CollisionBody } from '@denishussar/html5-game-engine';
import { PlayerModel } from './PlayerModel';

export class UnitModel extends AABBModel {
    public move: [number, number] = [0, 0];
    public screenPos: [number, number] = [0, 0];
    public name: string = 'name';
    public walk: boolean = false;
    public speed: number = 0;
    public initialSpeed: number = 800;
    public guid: string = '';
    public visible: boolean = false;

    public collision: CollisionBody;
    public player: PlayerModel;

    public constructor(public index: number) {
        super();

        this.speed = this.initialSpeed;
    }
}
